import React from 'react';
import { LeaveRequestStatus } from '../../types';
import './StatusBadge.css';

interface StatusBadgeProps {
  status: LeaveRequestStatus;
  size?: 'small' | 'medium' | 'large';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'medium' }) => {
  const getStatusConfig = (status: LeaveRequestStatus) => {
    switch (status) {
      case LeaveRequestStatus.DRAFT:
        return { label: 'Draft', className: 'status-draft' };
      case LeaveRequestStatus.PENDING:
        return { label: 'Pending', className: 'status-pending' };
      case LeaveRequestStatus.APPROVED_L1:
        return { label: 'Approved L1', className: 'status-approved-l1' };
      case LeaveRequestStatus.APPROVED:
        return { label: 'Approved', className: 'status-approved' };
      case LeaveRequestStatus.REJECTED:
        return { label: 'Rejected', className: 'status-rejected' };
      case LeaveRequestStatus.CANCELLED:
        return { label: 'Cancelled', className: 'status-cancelled' };
      default:
        return { label: status, className: 'status-default' };
    }
  };

  const { label, className } = getStatusConfig(status);

  return (
    <span className={`status-badge status-badge-${size} ${className}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
